import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { setPageMeta } from '../utils/seo';
import './Placeholder.css';

const EnterpriseRisk = () => {
  useEffect(() => {
    setPageMeta(
      'Enterprise AI Risk Management | Sapiencia.AI',
      'Sapiencia.AI enterprise AI risk management solutions overview.'
    );
  }, []);

  return (
    <div className="placeholder-page">
      <Navbar />
      <main className="placeholder-content">
        <h1>Enterprise AI Risk Management - Coming soon</h1>
      </main>
      <Footer />
    </div>
  );
};

export default EnterpriseRisk;
